import { React, useState, useEffect } from "react";
import {
  Modal,
  Box,
  Stack,
  Button,
  IconButton,
  Typography,
  Alert,
} from "@mui/material";
import { CloseOutlined } from "@mui/icons-material";
import { ufList } from "../../utils/ufList";

import { ReactComponent as IconDiamond } from "../../images/icon-diamond.svg";
import api from "../../services/api";
import { FieldAutocomplete, FieldSelect } from "../../components/Fields";
import ModalDialogs from "../../components/ModalDialogs";
import { getItemDecrypt } from "../../utils/cryptoData";

const styles = {
  modal: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    maxWidth: 400,
    width: "90%",
    bgcolor: "background.paper",
    borderRadius: "4px",
    boxShadow: 24,
  },
  modalHeader: {
    backgroundColor: "#1E729F !important",
    padding: "10px 15px 10px 15px",
    color: "#FFFFFF",
  },
  container: {
    display: "flex",
    justifyContent: "center",
    alingItens: "center",
    paddingBottom: "20px",
    paddingTop: "20px",
    borderRadius: "4px",
  },
  title: {
    fontWeight: "500",
    fontSize: "16px",
    lineHeight: "22px",
    color: "#063F5E",
  },
  autoComplete: {
    border: "1px solid #1E729F",
    borderRadius: 10,
  },
};

export default function AdicionarVinculos({
  openModal,
  setOpenModal,
  edit = false,
  reativar = false,
  modalHeaderText = "",
  dados = null,
  setRefresh,
  refresh,
}) {
  const [perfil, setPerfil] = useState("");
  const [perfilList, setPerfilList] = useState("");
  const [estado, setEstado] = useState("");
  const [municipio, setMunicipio] = useState("");
  const [municipioList, setMunicipioList] = useState("");
  const [estabelecimento, setEstabelecimento] = useState("");
  const [estabelecimentoList, setEstabelecimentoList] = useState([]);
  const [confirmAdd, setConfirmAdd] = useState(false);
  const [textModal, setTextModal] = useState("");
  const [subTextModal, setSubTextModal] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getPerfil();

    if (edit) {
      setTextModal("Vínculo editado com sucesso");
      setSubTextModal("Seu vínculo foi editado com sucesso");
    } else {
      setTextModal("Vínculo adicionado");
      setSubTextModal(
        "Seu vínculo foi adicionado ao sistema e está aguardando análise para homologação."
      );
    }
  }, []);

  async function handleSetMunicipio(uf_id) {
    try {
      const { data } = await api.post("/city", {
        state_id: parseInt(uf_id),
      });
      data.unshift({ co_ibge: "", no_descricao: "Selecione" });

      setMunicipioList(data);
    } catch (error) {
      console.error("Ocorreu um erro:", error.message);
    }
  }

  async function handleSetEstabelecimento(co_ibge) {
    try {
      const { data } = await api.post("/cnes", {
        co_ibge: parseInt(co_ibge),
      });

      data.unshift({ co_id: "", co_cnes: "", no_fantasia: "Selecione" });

      setEstabelecimentoList(data);
    } catch (error) {
      console.error("Ocorreu um erro:", error.message);
    }
  }

  async function clearAll() {
    setPerfil("");
    setEstado("");
    setMunicipio("");
    setMunicipioList([]);
    setEstabelecimento("");
    setEstabelecimentoList([]);
  }

  useEffect(() => {
    if (!(openModal || edit)) {
      clearAll();
    }

    if (openModal & (dados !== null)) {
      setLoading(true);
      setPerfil(dados.perfil);
      setEstado(dados.estado.toString());

      handleSetMunicipio(dados.estado);
      handleSetEstabelecimento(dados.municipio);

      setEstabelecimento(dados.estabelecimentoDeSaude);
      setMunicipio(dados.municipio);
      setLoading(false);
    }
  }, [openModal]);

  async function getPerfil() {
    try {
      setLoading(true);

      const { data } = await api.get("/perfil");
      setPerfilList(data);

      setLoading(false);
    } catch (error) {
      console.error("Ocorreu um erro:", error.message);
    }
  }

  async function handleEstado(uf_id) {
    setMunicipio("");
    setEstabelecimento("");
    setMunicipioList([]);
    setEstabelecimentoList([]);

    if (uf_id === undefined || uf_id === null) {
      setEstado("");
      return;
    }

    try {
      setEstado(uf_id.codigo_uf);

      const { data } = await api.post("/city", {
        state_id: uf_id.codigo_uf,
      });

      data.unshift({ co_ibge: "", no_descricao: "Selecione" });

      setMunicipioList(data);
    } catch (error) {
      console.error("Ocorreu um erro:", error.message);
    }
  }

  async function handleMunicipio(city_id) {
    setEstabelecimento("");
    setEstabelecimentoList([]);

    if (city_id === undefined || city_id === null) {
      setMunicipio("");
      return;
    }

    try {
      setMunicipio(city_id.co_ibge);

      const { data } = await api.post("/cnes", {
        co_ibge: city_id.co_ibge,
      });
      data.unshift({ co_id: "", co_cnes: "", no_fantasia: "Selecione" });

      setEstabelecimentoList(data);
    } catch (error) {
      console.error("Ocorreu um erro:", error.message);
    }
  }

  async function handleSubmit() {
    if (perfil === "" || estabelecimento === "") {
      return alert("OS campos marcados com * são obrigatórios");
    }

    if (edit) {
      try {
        const { data } = await api.put("/vinculo", {
          id: dados.vinculoId,
          id_perfil: perfil,
          id_estabelecimento_saude: estabelecimento,
        });

        if (data.status === "Error") {
          alert(data.message);
        } else {
          setOpenModal(false);
          setConfirmAdd(true);
          setRefresh(!refresh);
        }
      } catch (error) {
        console.error("Ocorreu um erro:", error.message);
      }
    } else {
      let usuario = getItemDecrypt("usuario");

      try {
        const { data } = await api.post("/vinculo", {
          id_usuario: usuario.co_id,
          perfil: perfil,
          estabelecimento: estabelecimento,
        });

        if (data.status === "Error") {
          alert(data.message);
        } else {
          setOpenModal(false);
          setConfirmAdd(true);
          setRefresh(!refresh);
        }
      } catch (error) {
        console.error("Ocorreu um erro:", error.message);
      }
    }
  }

  return (
    <div>
      <Modal
        open={openModal}
        onClose={setOpenModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={styles.modal}>
          <Box sx={styles.modalHeader}>
            <Stack
              direction={"row"}
              justifyContent={"space-between"}
              alignItems={"center"}
            >
              <Typography sx={{ fontSize: "1.3rem" }}>
                {modalHeaderText}
              </Typography>
              <IconButton>
                <CloseOutlined onClick={setOpenModal} sx={{ color: "white" }} />
              </IconButton>
            </Stack>
          </Box>
          {loading ? (
            <></>
          ) : (
            <Box sx={{ padding: 3, borderRadius: "4px" }}>
              <Stack direction={"column"} spacing={2}>
                <Alert icon={false} severity="info">
                  <Box
                    sx={{
                      display: "flex",
                      bgcolor: "rgb(229, 246, 253) !important",
                      alignItems: "center",
                      gap: "10px",
                    }}
                  >
                    <Box
                      width="24px"
                      height="24px"
                      bgcolor="transparent !important"
                    >
                      <IconDiamond width="24px" height="24px" fill="#FC8518" />
                    </Box>

                    <span>
                      Este marcador indica campos de preenchimento obrigatório
                    </span>
                  </Box>
                </Alert>
                <FieldSelect
                  label="Perfil"
                  value={perfil}
                  setValue={setPerfil}
                  items={perfilList.map((c) => {
                    return { id: c.co_id, label: c.no_perfil };
                  })}
                  required
                />

                <FieldAutocomplete
                  label="Estado"
                  getOptionLabel={(option) => option.unidade_federativa || ""}
                  options={ufList}
                  value={
                    ufList.find((option) => option.codigo_uf === estado) || null
                  }
                  setValue={(event, newValue) => {
                    handleEstado(newValue);
                  }}
                  required
                  defaultValue={""}
                />

                <FieldAutocomplete
                  label="Município"
                  disabled={municipioList?.length === 0}
                  getOptionLabel={(option) => option.no_descricao || ""}
                  options={municipioList}
                  value={
                    municipioList
                      ? municipioList.find(
                          (option) => option.co_ibge === municipio
                        )
                      : null
                  }
                  setValue={(event, newValue) => {
                    handleMunicipio(newValue);
                  }}
                  required
                  defaultValue={""}
                />

                <FieldAutocomplete
                  label="Estabelecimento de Saúde"
                  disabled={!municipio}
                  getOptionLabel={(option) =>
                    `${option.co_cnes} - ${option.no_fantasia}` || ""
                  }
                  options={estabelecimentoList}
                  value={
                    estabelecimentoList
                      ? estabelecimentoList.find(
                          (option) => option.co_id === estabelecimento
                        )
                      : null
                  }
                  setValue={(event, newValue) => {
                    setEstabelecimento(newValue?.co_id ?? "");
                  }}
                  required
                  defaultValue={""}
                />
              </Stack>
              <Stack direction="column" spacing={2} sx={{ mt: 5 }}>
                <Box>
                  <Stack direction={"row"} justifyContent={"end"} gap={1}>
                    <Button
                      variant="outlined"
                      onClick={setOpenModal}
                      sx={{
                        color: "#1E729F !important",
                        border: "1px solid #1E729F",
                      }}
                    >
                      {" "}
                      Cancelar{" "}
                    </Button>
                    {edit ? (
                      <Button variant="contained" onClick={handleSubmit}>
                        {" "}
                        Editar{" "}
                      </Button>
                    ) : (
                      <Button
                        variant="contained"
                        onClick={handleSubmit}
                        sx={{ bgcolor: "#1E729F !important" }}
                      >
                        {" "}
                        Salvar{" "}
                      </Button>
                    )}
                  </Stack>
                </Box>
              </Stack>
            </Box>
          )}
        </Box>
      </Modal>
      <ModalDialogs
        open={confirmAdd}
        onClose={() => setConfirmAdd(false)}
        modalType="success"
        title="Sucesso"
        body={
          <Box sx={{ width: { xs: "100%", sm: "400px" } }}>
            <Box>{textModal}</Box>
            <Box
              sx={{
                fontSize: "16px",
                fontWeight: "400",
              }}
            >
              {subTextModal}
            </Box>
          </Box>
        }
      />
    </div>
  );
}
